__turbopack_context__.v({
  "accordion": "eM2zfa_accordion",
  "body": "eM2zfa_body",
  "bodyDesktop": "eM2zfa_bodyDesktop",
  "bodyMobile": "eM2zfa_bodyMobile",
  "carousel": "eM2zfa_carousel",
  "categoryBody": "eM2zfa_categoryBody",
  "categoryBodyDesktop": "eM2zfa_categoryBodyDesktop",
  "categoryBodyMobile": "eM2zfa_categoryBodyMobile",
  "categoryLink": "eM2zfa_categoryLink",
  "categoryNote": "eM2zfa_categoryNote",
  "categoryTitle": "eM2zfa_categoryTitle",
  "copy": "eM2zfa_copy",
  "copyHead": "eM2zfa_copyHead",
  "cta": "eM2zfa_cta",
  "intro": "eM2zfa_intro",
  "introCopy": "eM2zfa_introCopy",
  "list": "eM2zfa_list",
  "media": "eM2zfa_media",
  "row": "eM2zfa_row",
  "rowImageLeft": "eM2zfa_rowImageLeft",
  "section": "eM2zfa_section",
  "title": "eM2zfa_title",
  "titleDesktop": "eM2zfa_titleDesktop",
  "titleMobile": "eM2zfa_titleMobile",
});
